/* Geo Gear Co glass design renderer (shared by the product picker, cart and proof page).
   Needs window.GGC_GLASS_CFG = {src: design photo url, letters: [letter card js urls]} before init().
   API: GGCGlass.init(), .names, .fonts, .onChange(fn), .ready(), .draw(canvas, design, name, font), .source(design, name, font),
        .squeeze(design, name, font) -> 1 = full size, lower = name shrunk to fit, .parse(text) -> [{g, d, name, font}],
        .drawGlass(canvas, design, name, font) -> design frosted onto the glass photo (cfg.glass = {src, cx, cy, w, grain}).
   font = a key of FONTS ('milonga', 'cinzel'); lines without "Font:" (orders before the font choice) use Cinzel.
   More fonts: cfg.fonts = {key: {label, src: font file url, family, weight}} (e.g. OptiJake, Ballpark once licensed).
   Designs 1-9 are cut from the 12-design photo (sample names erased; only the customer's name is ever shown); design 10 (Oars) is Ty's own artwork, traced to a vector path (VEC).
   Frost finish follows Ty's mockup generator: brightness 245, opacity 0.78, fine grain (single glass 0.11), seed 1701. */
(function(){
  if(window.GGCGlass) return;
  var NAMES=['Antlers','Bass','Buck','Buck & pines','Jumping fish','Ornate monogram','Script monogram','Wreath monogram','Split monogram','Oars'];
  var CX=[[0,183],[192,186],[387,213]], RY=[[0,147],[156,147],[312,137],[458,142]];
  var ND=10, NP=9, AW=480, AH=384, CACHE='ggc-glass-art-v2', ART={}, BLANK={}, BARS={}, MEMO={}, memoN=0, started=false, subs=[], P2D={}, GLASS=null, FROST={}, frostN=0;
  /* name lettering, set by the decanter style (picker data-font): Classic = Milonga, Minimalist = Ballpark, Modern = OptiJake, everything else = Cinzel.
     mixed: true = the name as typed, first letter capitalised ("Tyler", "McKay"); false = the design's case (caps or small caps) */
  var FONTS={
    milonga:{label:'Milonga',family:'Milonga',weight:400,css:'https://fonts.googleapis.com/css2?family=Milonga&display=swap',mixed:true},
    cinzel:{label:'Cinzel',family:'Cinzel',weight:900,css:'https://fonts.googleapis.com/css2?family=Cinzel:wght@900&display=swap',mixed:true}
  }, OLD_FONT='cinzel', FREADY={};
  function fkey(f){ f=String(f||'').toLowerCase().replace(/[^a-z]/g,''); return FONTS[f]?f:OLD_FONT; }
  function face(k,px){ var F=FONTS[k]; return F.weight+' '+px+'px "'+F.family+'"'; }
  /* er: areas to erase; seeds: pixels inside a monogram letter to flood-erase; t: [centre x, centre y, cap height, max width, case U=caps S=first cap + small caps];
     L: monogram letter. k 'S'/'R' = letter card (script / Roman), b = [top bar left x, top bar top y, bar width];
     k 'U' = Cinzel glyph, b = [centre x, centre y, width, height], s = max stretch */
  var CFG={
    1:{er:[[43,218,395,57]],t:[240,246,46,340,'U']},
    2:{er:[[128,171,282,58]],t:[269,199.5,46,260,'U']},
    3:{er:[[131,258,219,53]],t:[240,284,37,200,'U']},
    4:{er:[[0,297,480,87]],t:[240,325.5,45,370,'U']},
    5:{er:[[60,50,380,79]],t:[250,95.5,55,350,'U']},
    6:{er:[[62,223,357,67]],seeds:[[240,125]],t:[240,256,52,340,'U'],L:{k:'U',b:[240,144,108,76],s:1.15}},
    7:{er:[[84,188,312,52]],seeds:[[210,100],[230,300]],t:[240,214,44,290,'S'],L:{k:'S',b:[85,182,310]}},
    8:{er:[[147,184,186,34]],seeds:[[240,140],[240,250]],t:[240,203.5,26,170,'S'],L:{k:'R',b:[147,181,186]}},
    9:{er:[[59,205,362,66]],seeds:[[250,45],[230,335]],t:[240,237.5,44,330,'S'],L:{k:'R',b:[59,194,362]}},
    10:{er:[],t:[240,235.9,50,300,'S']}
  };
  /* vector artwork (units: w x h pixels of Ty's art file); the name sits between the two bars (art y 71-117) */
  var VEC={10:{w:166,h:147,d:"M16.31,0.28c-0.07,0.17 -0.49,0.46 -1,0.72 -3.66,1.82 -10.54,9.12 -12.68,13.45 -1.06,2.15 -1.06,5.55 0.01,7.36 2.09,3.52 12.9,14.53 21.16,21.51 0.94,0.79 4.8,3.83 5.21,4.1 0.35,0.23 0.69,0.16 0.78,-0.15 0.04,-0.12 0.1,-2.94 0.14,-6.28 0.04,-3.34 0.12,-7.03 0.2,-8.19 0.2,-3.44 0.12,-3.38 4.74,-3.36 8.53,0.04 14,0.35 14,0.81 0,0.28 -0.29,0.62 -0.6,0.75 -0.21,0.09 -3.06,0.12 -7.97,0.12 -7.49,-0.01 -7.65,-0.01 -7.96,0.24 -0.44,0.35 -0.44,0.31 -0.59,6.12 -0.21,8.09 -0.3,9.45 -0.61,10.16 -0.34,0.79 -0.34,0.86 0.14,1.32 0.56,0.55 4.29,3.01 4.56,3.01 0.07,0 0.35,0.15 0.61,0.33 0.26,0.19 1.32,0.76 2.36,1.29 1.02,0.53 1.99,1.02 2.12,1.11 0.14,0.07 0.5,0.25 0.81,0.39 0.31,0.14 0.76,0.36 1,0.5 0.24,0.14 0.75,0.4 1.12,0.57 0.78,0.35 1.79,0.86 2.25,1.12 0.17,0.1 1.52,0.78 3,1.51 1.48,0.72 2.86,1.41 3.06,1.51 0.62,0.34 2.46,1.29 3,1.55 0.28,0.14 0.61,0.31 0.75,0.39 0.14,0.09 0.99,0.54 1.88,1.01 0.9,0.47 1.91,1.05 2.25,1.27 0.35,0.21 1.04,0.66 1.54,0.97 0.99,0.65 1.18,1.05 0.62,1.36 -0.31,0.16 -22.11,0.31 -48.81,0.34l-13.41,0.01 0,1.81 0,1.81 83,0 83,0 0,-1.79 0,-1.8 -2.09,-0.07c-1.14,-0.05 -15.16,-0.09 -31.16,-0.09 -22.45,0 -29.11,-0.04 -29.23,-0.15 -0.45,-0.45 -0.03,-0.97 1.75,-2.14 1.85,-1.2 2.61,-1.62 4.72,-2.64 0.38,-0.17 0.89,-0.44 1.12,-0.59 0.24,-0.14 0.69,-0.36 1,-0.5 0.31,-0.14 0.74,-0.34 0.94,-0.45 0.55,-0.3 2.41,-1.27 3,-1.55 0.28,-0.14 0.68,-0.34 0.88,-0.45 0.21,-0.11 1.68,-0.86 3.25,-1.66 2.6,-1.32 5.22,-2.67 7.81,-4.03 0.51,-0.26 1.36,-0.74 1.88,-1.04 0.51,-0.3 1.19,-0.68 1.49,-0.82 0.91,-0.44 2.69,-1.69 3.12,-2.19 0.45,-0.5 0.44,-0.42 0.1,-1.98 -0.2,-0.85 -0.3,-3.11 -0.56,-12.18 -0.09,-3.02 -0.09,-3.05 -0.4,-3.3 -0.29,-0.24 -0.45,-0.24 -7.81,-0.15 -8.03,0.1 -8.12,0.09 -8.69,-0.51 -0.56,-0.6 -0.78,-0.46 -1.77,1.2 -0.5,0.82 -1.11,1.82 -1.35,2.21 -0.24,0.4 -0.55,0.9 -0.69,1.14 -0.14,0.24 -0.42,0.69 -0.64,1.02 -0.4,0.6 -0.89,1.44 -1.62,2.8 -0.56,1.05 -1.41,2.58 -2.05,3.69 -0.96,1.66 -1.46,2.64 -2.81,5.38 -0.72,1.48 -1.41,2.85 -1.52,3.06 -0.11,0.2 -0.34,0.65 -0.5,1 -0.16,0.34 -0.36,0.76 -0.46,0.94 -0.35,0.66 -0.56,1.1 -1.05,2.12 -0.28,0.59 -0.79,1.66 -1.14,2.39 -0.35,0.72 -0.64,1.39 -0.64,1.48 0,0.09 -0.97,1.14 -2.15,2.35 -1.19,1.21 -2.83,2.89 -3.64,3.73 -0.81,0.85 -1.66,1.61 -1.88,1.71 -0.68,0.28 -19.64,0.24 -20.15,-0.05 -0.57,-0.31 -5.8,-5.58 -6.84,-6.88 -0.95,-1.19 -1.5,-2.06 -2.05,-3.23 -0.33,-0.7 -0.5,-1.06 -2.24,-4.69 -1.3,-2.73 -2,-4.11 -3.99,-7.85 -0.93,-1.74 -1.99,-3.66 -2.81,-5.09 -0.26,-0.45 -0.7,-1.21 -0.97,-1.69 -0.54,-0.94 -1.09,-1.86 -1.75,-2.91 -0.23,-0.35 -0.6,-0.95 -0.82,-1.31 -0.23,-0.35 -0.61,-0.96 -0.86,-1.35 -0.25,-0.38 -0.56,-0.91 -0.7,-1.19 -0.14,-0.28 -0.4,-0.56 -0.57,-0.65 -0.19,-0.09 -0.35,-0.3 -0.42,-0.57 -0.15,-0.55 -0.86,-1.54 -2.98,-4.12 -3.19,-3.91 -13.28,-15.04 -17.74,-19.56 -3.4,-3.44 -4.39,-4.33 -5.55,-4.95 -0.39,-0.21 -0.75,-0.5 -0.82,-0.66 -0.12,-0.28 -0.14,-0.28 -2.81,-0.28 -2.67,0 -2.69,0 -2.81,0.28zm11.66,11.84c2.41,0.12 2.77,0.25 2.77,0.88 0,0.84 0.34,0.81 -8.1,0.72 -8.09,-0.09 -7.81,-0.1 -8.15,0.53 -0.17,0.35 -0.33,3.75 -0.47,10.78 -0.07,4.26 -0.1,4.6 -0.33,4.85 -0.3,0.34 -0.72,0.34 -1.02,0 -0.49,-0.54 -0.25,-15.96 0.26,-17.19 0.23,-0.54 0.36,-0.6 1.44,-0.68 1.41,-0.1 11.14,-0.01 13.6,0.11zm2.96,8.45c4.42,0.07 8,0.29 8.44,0.49 0.44,0.2 0.47,0.64 0.07,0.89 -0.29,0.19 -1.06,0.21 -8.2,0.2l-7.89,-0.01 -0.29,0.29 -0.29,0.29 -0.09,5.49c-0.09,6.03 -0.24,9.24 -0.45,9.97 -0.19,0.61 -0.64,0.85 -1,0.53 -0.24,-0.23 -0.25,-0.38 -0.25,-5.92 0.01,-7.85 0.14,-11.06 0.46,-11.5 0.51,-0.68 1.75,-0.9 4.47,-0.81 0.69,0.03 2.94,0.07 5,0.11zM144.31,0.28c-0.07,0.16 -0.49,0.47 -0.96,0.72 -0.85,0.44 -2.85,2.11 -3.86,3.23 -0.29,0.33 -1.59,1.69 -2.86,3.02 -2.7,2.83 -3.52,3.71 -6.5,6.94 -1.2,1.3 -2.77,2.99 -3.49,3.75 -0.71,0.75 -2.05,2.27 -2.99,3.38 -0.94,1.1 -2.06,2.42 -2.52,2.94 -1.65,1.89 -3.05,3.7 -3.51,4.55 -0.55,1.05 -0.68,1.02 4.97,0.78 2.66,-0.11 6.49,-0.23 8.47,-0.24 5.15,-0.04 4.76,-0.45 4.94,5.25 0.35,11.65 0.39,12.1 0.95,12.24 0.44,0.11 0.74,-0.05 1.96,-1.04 0.59,-0.46 1.81,-1.45 2.73,-2.19 4.16,-3.31 13.56,-12.54 19.45,-19.07 1.69,-1.89 2.55,-3.17 2.79,-4.17 0.15,-0.68 0.16,-3.5 0,-4.16 -0.91,-3.98 -8.85,-12.89 -13.56,-15.25 -0.42,-0.21 -0.8,-0.5 -0.88,-0.66 -0.12,-0.28 -0.15,-0.28 -2.56,-0.28 -2.41,0 -2.44,0 -2.56,0.28zm8.55,11.9c0.55,0.5 0.74,2.71 0.86,10.07 0.14,7.35 0.06,8.12 -0.79,8.12 -0.82,0 -0.88,-0.41 -1.14,-8.88 -0.11,-3.75 -0.25,-6.94 -0.31,-7.09 -0.26,-0.7 -0.05,-0.69 -8.14,-0.56 -7.99,0.12 -8.12,0.12 -8.46,-0.5 -0.24,-0.42 0.09,-0.96 0.69,-1.12 0.59,-0.17 6.24,-0.31 11.81,-0.3 4.94,0.01 5.22,0.03 5.47,0.25zm-8.86,8.43c0.82,0.39 0.88,0.65 1,5.05 0.16,5.5 0.16,12.34 -0.01,12.84 -0.19,0.55 -0.54,0.71 -0.94,0.45 -0.65,-0.42 -0.72,-1.19 -0.94,-9.75 -0.16,-6.47 -0.19,-6.74 -0.81,-6.89 -0.19,-0.05 -3.33,-0.03 -6.97,0.06 -8.35,0.17 -9.2,0.1 -9.2,-0.81 0,-0.59 0.38,-0.68 3.65,-0.86 7.06,-0.41 13.45,-0.45 14.22,-0.09zM0.79,118.51l-0.79,0.25 0,1.43 0,1.41 0.86,0.2c0.78,0.17 2.96,0.2 19.38,0.2 16.89,0 18.51,0.01 18.7,0.2 0.33,0.33 0.19,0.55 -0.84,1.36 -0.53,0.41 -1.44,1.14 -2.04,1.62 -3.19,2.58 -5.34,4.26 -6.1,4.79 -1.77,1.21 -2.29,1.54 -2.96,1.84 -0.38,0.17 -1,0.49 -1.38,0.68 -0.39,0.2 -1.05,0.46 -1.5,0.57 -0.44,0.11 -0.96,0.29 -1.15,0.39 -0.19,0.1 -0.85,0.31 -1.48,0.47 -1.01,0.28 -2.27,0.9 -2.92,1.44 -1.12,0.95 -1.06,4.19 0.12,5.92 0.95,1.39 3.92,4.01 5.4,4.76 0.24,0.12 0.51,0.39 0.62,0.59l0.21,0.36 1.84,0c1.74,0 1.84,-0.01 1.91,-0.25 0.05,-0.15 0.31,-0.4 0.6,-0.59 1.49,-0.91 1.61,-1.18 2.59,-5.75 0.4,-1.89 1.54,-3.33 5.25,-6.6 3.12,-2.76 9.81,-9.01 11.5,-10.75 0.38,-0.39 0.84,-0.79 1.02,-0.89 0.51,-0.26 66.19,-0.26 66.7,0 0.19,0.1 0.85,0.7 1.46,1.32 0.62,0.64 1.8,1.77 2.62,2.54 0.82,0.76 2.01,1.86 2.62,2.45 1.75,1.66 4.16,3.9 6.5,6.01 3.64,3.3 4.17,4 4.56,6.01 0.71,3.77 1.19,4.83 2.54,5.66 0.19,0.11 0.41,0.35 0.49,0.53 0.14,0.3 0.15,0.3 1.96,0.3l1.82,0 0.21,-0.36c0.11,-0.21 0.49,-0.51 0.88,-0.71 1.54,-0.78 4.39,-3.33 5.39,-4.8 0.88,-1.31 1.1,-3.79 0.44,-5.1 -0.41,-0.84 -1.89,-1.8 -3.2,-2.09 -0.51,-0.12 -1.19,-0.33 -1.49,-0.45 -0.3,-0.12 -0.88,-0.31 -1.27,-0.42 -0.96,-0.25 -4.08,-1.85 -5.36,-2.75 -0.9,-0.64 -2.31,-1.71 -3.36,-2.56 -0.55,-0.45 -1.3,-1.04 -1.66,-1.31 -2.08,-1.59 -4.24,-3.46 -4.33,-3.74 -0.06,-0.17 0.01,-0.33 0.2,-0.47 0.26,-0.21 1.1,-0.23 18.59,-0.23 16.23,0 18.4,-0.03 19.18,-0.2l0.86,-0.2 0,-1.41 0,-1.43 -0.82,-0.26 -0.82,-0.25 -81.4,0.01c-80.76,0 -81.39,0 -82.16,0.25z"}};
  function vecArt(v){
    var o=canvas(AW,AH), x=o.getContext('2d'); x.fillStyle='#fff'; x.fillRect(0,0,AW,AH);
    var k=Math.min(AW*0.82/v.w, AH*0.82/v.h);
    x.translate((AW-v.w*k)/2,(AH-v.h*k)/2); x.scale(k,k); x.fillStyle='#000'; x.fill(new Path2D(v.d));
    return o;
  }
  function setArt(o){ for(var n in o){ ART[n]=o[n]; delete BLANK[n]; delete BARS[n]; } for(var v in VEC){ if(!ART[v]) ART[v]=vecArt(VEC[v]); } changed(); }
  function cfg(){ return window.GGC_GLASS_CFG||{}; }
  function canvas(w,h){ var c=document.createElement('canvas'); c.width=w; c.height=h; return c; }
  function changed(){ MEMO={}; memoN=0; FROST={}; frostN=0; subs.forEach(function(f){ try{ f(); }catch(e){} }); }
  /* artwork: crop each design from the photo, clean it, centre it on white */
  function makeArt(img){
    var W=img.naturalWidth, s=W/600, out={};
    var c=canvas(W,img.naturalHeight), x=c.getContext('2d',{willReadFrequently:true}); x.drawImage(img,0,0);
    for(var n=1;n<=NP;n++){
      var cc=CX[(n-1)%3], rr=RY[Math.floor((n-1)/3)], ins=5;
      var rx=Math.round((cc[0]+ins)*s), ry=Math.round((rr[0]+ins)*s), rw=Math.round((cc[1]-2*ins)*s), rh=Math.round((rr[1]-2*ins)*s);
      var d=x.getImageData(rx,ry,rw,rh), p=d.data, x0=rw, y0=rh, x1=0, y1=0;
      for(var i=0;i<p.length;i+=4){
        var r=p[i], g=p[i+1], b=p[i+2], v;
        if(r-Math.max(g,b)>35){ v=255; } else { v=(0.3*r+0.59*g+0.11*b-45)*255/130; v=v<0?0:(v>255?255:v); }
        p[i]=p[i+1]=p[i+2]=v; p[i+3]=255;
        if(v<150){ var k=i/4, px=k%rw, py=(k/rw)|0; if(px<x0)x0=px; if(px>x1)x1=px; if(py<y0)y0=py; if(py>y1)y1=py; }
      }
      if(x1<=x0||y1<=y0){ x0=0; y0=0; x1=rw-1; y1=rh-1; }
      var t=canvas(rw,rh); t.getContext('2d').putImageData(d,0,0);
      var o=canvas(AW,AH), ox=o.getContext('2d'); ox.fillStyle='#fff'; ox.fillRect(0,0,AW,AH);
      var bw=x1-x0+1, bh=y1-y0+1, kk=Math.min(AW*0.82/bw, AH*0.82/bh);
      ox.imageSmoothingEnabled=true; ox.imageSmoothingQuality='high';
      ox.drawImage(t,x0,y0,bw,bh,(AW-bw*kk)/2,(AH-bh*kk)/2,bw*kk,bh*kk);
      out[n]=o;
    }
    return out;
  }
  /* blank art: sample name (and monogram letter) removed */
  function makeBlank(src,n){
    var c=canvas(AW,AH), x=c.getContext('2d',{willReadFrequently:true}), cf=CFG[n];
    x.fillStyle='#fff'; x.fillRect(0,0,AW,AH); x.drawImage(src,0,0,AW,AH);
    if(cf.seeds){
      var id=x.getImageData(0,0,AW,AH), p=id.data, N=AW*AH, m=new Uint8Array(N);
      cf.seeds.forEach(function(sd){
        var k0=sd[1]*AW+sd[0]; if(p[k0*4]>=200) return;
        var st=[k0]; m[k0]=1;
        while(st.length){
          var k=st.pop(), py=(k/AW)|0, nb=[k+1,k-1,k+AW,k-AW];
          for(var j=0;j<4;j++){ var q=nb[j]; if(q<0||q>=N) continue; if(j<2&&((q/AW)|0)!==py) continue; if(!m[q]&&p[q*4]<200){ m[q]=1; st.push(q); } }
        }
      });
      for(var k=0;k<N;k++){
        if(m[k]!==1) continue;
        var px=k%AW, py2=(k/AW)|0;
        for(var dy=-2;dy<=2;dy++) for(var dx=-2;dx<=2;dx++){
          var X=px+dx, Y=py2+dy; if(X<0||Y<0||X>=AW||Y>=AH) continue;
          var q2=Y*AW+X; if(m[q2]) continue;
          if((Math.abs(dx)<=1&&Math.abs(dy)<=1)||p[q2*4]>120) m[q2]=2;
        }
      }
      for(var k3=0;k3<N;k3++){ if(m[k3]){ p[k3*4]=p[k3*4+1]=p[k3*4+2]=255; } }
      x.putImageData(id,0,0);
    }
    x.fillStyle='#fff'; cf.er.forEach(function(r){ x.fillRect(r[0],r[1],r[2],r[3]); });
    return c;
  }
  function glyph(x,ch,b,st){
    x.save(); x.font=face('cinzel',100); x.textAlign='left'; x.textBaseline='alphabetic';
    var m=x.measureText(ch), gl=m.actualBoundingBoxLeft||0, gr=m.actualBoundingBoxRight||m.width, ga=m.actualBoundingBoxAscent||70, gd=m.actualBoundingBoxDescent||0;
    var gw=gl+gr, gh=ga+gd; if(gw<=0||gh<=0){ x.restore(); return; }
    var sy=b[3]/gh, sx=b[2]/gw;
    if(sx>sy*st) sx=sy*st;
    if(sx<sy*0.62) sy=sx/0.62;
    if(sx>sy*st) sx=sy*st;
    x.translate(b[0]-gw*sx/2+gl*sx, b[1]-gh*sy/2+ga*sy); x.scale(sx,sy);
    x.fillText(ch,0,0); x.restore();
  }
  function caseIt(s,k){ return k==='U'?s.toUpperCase():s.charAt(0).toUpperCase()+s.slice(1).toLowerCase(); }
  function nameCase(s,fk,t){ return FONTS[fk].mixed?s.charAt(0).toUpperCase()+s.slice(1):caseIt(s,t[4]); }
  /* works out size and squeeze for a name; returns {s, fs, sx, cap, q} (q = how much it shrank, 1 = none) */
  function fit(x,txt,t,fk){
    var s=nameCase(txt,fk,t); x.font=face(fk,100);
    var cap=(x.measureText('H').actualBoundingBoxAscent||70)/100, fs=t[2]/cap, fs0=fs;
    var m=x.measureText(s), w=((m.actualBoundingBoxLeft||0)+(m.actualBoundingBoxRight||m.width))/100*fs, sx=1;
    if(w>t[3]){ sx=Math.max(t[3]/w,0.66); if(w*sx>t[3]) fs*=t[3]/(w*sx); }
    return {s:s,fs:fs,sx:sx,cap:cap,q:sx*fs/fs0};
  }
  /* designs with a bar above and below the name: find the two bars around the name box (rows that are dark across the middle of it) */
  function findBars(x,t){
    try{
      var bx=Math.round(t[0]-t[3]*0.3), bw=Math.round(t[3]*0.6), y0=Math.max(0,Math.round(t[1]-t[2]*2.2)), y1=Math.min(AH,Math.round(t[1]+t[2]*2.2));
      var d=x.getImageData(bx,y0,bw,y1-y0).data, H=y1-y0, dark=[];
      for(var r=0;r<H;r++){ var c=0; for(var i=0;i<bw;i++){ if(d[(r*bw+i)*4]<128) c++; } dark.push(c>bw*0.85); }
      var mid=Math.round(t[1]-y0), a=mid, b=mid;
      if(dark[mid]) return null;
      while(a>0&&!dark[a]) a--; while(b<H-1&&!dark[b]) b++;
      if(!dark[a]||!dark[b]) return null;
      var e=b; while(e<H-1&&dark[e+1]) e++;
      var top=y0+a+1, bot=y0+b, gap=bot-top;
      if(gap<t[2]*1.1||gap>t[2]*3) return null;
      return {top:top,bot:bot,end:y0+e+1};
    }catch(err){ return null; }
  }
  /* name that fills the space between the bars: tallest letter just under the top bar, baseline just above the bottom bar */
  function fitBars(x,txt,t,fk,b){
    var s=nameCase(txt,fk,t); x.font=face(fk,100);
    var m=x.measureText(s), asc=(m.actualBoundingBoxAscent||70)/100, w=((m.actualBoundingBoxLeft||0)+(m.actualBoundingBoxRight||m.width))/100;
    var gap=b.bot-b.top, pad=Math.max(3,gap*0.09), fs=(gap-2*pad)/asc, fs0=fs, sx=1, maxw=t[3]*1.1;
    if(w*fs>maxw){ sx=Math.max(maxw/(w*fs),0.66); if(w*fs*sx>maxw) fs*=maxw/(w*fs*sx); }
    var base=b.bot-pad-(fs0-fs)*asc/2;
    return {s:s,fs:fs,sx:sx,base:base,knock:Math.max(3,gap*0.05),q:sx*fs/fs0};
  }
  function nameText(x,txt,t,fk,bars){
    x.save();
    if(bars){
      var g=fitBars(x,txt,t,fk,bars);
      x.translate(t[0],g.base); x.scale(g.sx*g.fs/100,g.fs/100); x.font=face(fk,100);
      x.textAlign='center'; x.textBaseline='alphabetic';
      /* white outline first: where a tail (y, g, p...) runs through the bottom bar, the bar gets a clean break */
      x.lineJoin='round'; x.lineCap='round'; x.strokeStyle='#fff'; x.lineWidth=g.knock*2*100/g.fs; x.strokeText(g.s,0,0);
      x.fillStyle='#000'; x.fillText(g.s,0,0);
    } else {
      var f=fit(x,txt,t,fk);
      x.translate(t[0],t[1]+f.cap*f.fs/2); x.scale(f.sx*f.fs/100,f.fs/100);
      x.textAlign='center'; x.textBaseline='alphabetic'; x.fillStyle='#000'; x.fillText(f.s,0,0);
    }
    x.restore();
  }
  function card(x,set,ch,b){
    var LT=window.GGC_GLASS_LETTERS, key=set+ch, p=P2D[key];
    if(!p){ if(!LT||!LT[set]||!LT[set][ch]) return; p=P2D[key]=new Path2D(LT[set][ch]); }
    x.save(); x.translate(b[0],b[1]); x.scale(b[2]/500,b[2]/500); x.fillStyle='#000'; x.fill(p); x.restore();
  }
  function initial(name){ return (name.match(/[A-Za-z]/)||['A'])[0].toUpperCase(); }
  function lettersOk(n,name){
    var k=CFG[n].L&&CFG[n].L.k; if(!(k==='S'||k==='R')) return true;
    var LT=window.GGC_GLASS_LETTERS; return !!(LT&&LT[k]&&LT[k][initial(name)]);
  }
  function compose(n,name,fk){
    var key=n+'|'+name+'|'+fk; if(MEMO[key]) return MEMO[key];
    if(!BLANK[n]) BLANK[n]=makeBlank(ART[n],n);
    var c=canvas(AW,AH), x=c.getContext('2d'), cf=CFG[n];
    x.drawImage(BLANK[n],0,0); x.fillStyle='#000';
    if(cf.L){
      if(cf.L.k==='S'||cf.L.k==='R') card(x,cf.L.k,initial(name),cf.L.b);
      else glyph(x,initial(name),cf.L.b,cf.L.s);
    }
    if(BARS[n]===undefined) BARS[n]=findBars(x,cf.t);
    if(name) nameText(x,name,cf.t,fk,BARS[n]);
    if(++memoN>120){ MEMO={}; memoN=0; }
    MEMO[key]=c; return c;
  }
  /* no name yet: the design with the photo's sample name taken out (monograms show a plain "A" until a name is typed) */
  function blank(n){ try{ if(!BLANK[n]) BLANK[n]=makeBlank(ART[n],n); return BLANK[n]; }catch(e){ return ART[n]; } }
  function source(n,name,font){
    n=+n; if(!CFG[n]||!ART[n]) return null;
    name=(name||'').trim(); var fk=fkey(font);
    if(!name){ if(CFG[n].L&&FREADY.cinzel&&lettersOk(n,'A')){ try{ return compose(n,'',fk); }catch(e){} } return blank(n); }
    if(!FREADY[fk]||!FREADY.cinzel||!lettersOk(n,name)) return blank(n);
    try{ return compose(n,name,fk); }catch(e){ return blank(n); }
  }
  function draw(el,n,name,font){
    var src=n?source(n,name,font):null, x=el.getContext('2d');
    x.fillStyle='#fff'; x.fillRect(0,0,el.width,el.height);
    if(!src){ el.classList.remove('is-ready'); return false; }
    x.imageSmoothingEnabled=true; x.imageSmoothingQuality='high';
    var k=Math.min(el.width/AW,el.height/AH), w=AW*k, h=AH*k;
    x.drawImage(src,(el.width-w)/2,(el.height-h)/2,w,h); el.classList.add('is-ready');
    return true;
  }
  /* frosted engraving: fixed-seed noise so the grain is the same every time */
  function rand(seed){ return function(){ seed=(seed+1831565813)|0; var t=Math.imul(seed^(seed>>>15),1|seed); t=(t+Math.imul(t^(t>>>7),61|t))^t; return ((t^(t>>>14))>>>0)/4294967296; }; }
  function frost(src,W,H,grain){
    var t=canvas(W,H), x=t.getContext('2d',{willReadFrequently:true});
    x.fillStyle='#fff'; x.fillRect(0,0,W,H); x.imageSmoothingEnabled=true; x.imageSmoothingQuality='high'; x.drawImage(src,0,0,W,H);
    var id=x.getImageData(0,0,W,H), p=id.data, r=rand(1701), gray=245, op=0.78;
    for(var i=0;i<p.length;i+=4){
      var cov=255-p[i], n=r()*2-1;
      if(cov<=0){ p[i+3]=0; continue; }
      var tone=Math.round(Math.max(0,Math.min(255,gray+n*grain*150)));
      var a=Math.round(cov*Math.max(0,Math.min(1,op*(1+n*grain))));
      p[i]=p[i+1]=p[i+2]=tone; p[i+3]=a;
    }
    x.putImageData(id,0,0); return t;
  }
  function drawGlass(el,n,name,font){
    var g=cfg().glass; if(!GLASS||!g) return false;
    var x=el.getContext('2d'), W=el.width, H=el.height;
    x.imageSmoothingEnabled=true; x.imageSmoothingQuality='high';
    x.drawImage(GLASS,0,0,W,H);
    var src=n?source(n,name,font):null; if(!src) return true;
    var w=Math.round(g.w*W), h=Math.round(w*AH/AW), key=n+'|'+(name||'').trim()+'|'+fkey(font)+'|'+w+'|'+(src===ART[n]?'a':'c');
    var f=FROST[key]; if(!f){ f=FROST[key]=frost(src,w,h,g.grain||0.11); if(++frostN>60){ FROST={}; frostN=0; FROST[key]=f; } }
    x.drawImage(f,Math.round(g.cx*W-w/2),Math.round(g.cy*H-h/2));
    return true;
  }
  function loadGlass(){
    var g=cfg().glass; if(!g||!g.src) return;
    var im=new Image(); im.onload=function(){ GLASS=im; changed(); }; im.src=g.src;
  }
  var MX=null;
  function squeeze(n,name,font){
    n=+n; name=(name||'').trim(); if(!CFG[n]||!name) return 1;
    if(!MX) MX=canvas(10,10).getContext('2d');
    MX.save(); var fk=fkey(font), q=BARS[n]?fitBars(MX,name,CFG[n].t,fk,BARS[n]).q:fit(MX,name,CFG[n].t,fk).q; MX.restore(); return q;
  }
  /* "Glass 2: Design 7 · Script monogram – Gilbert · Font: Milonga" -> {g:2, d:7, name:'Gilbert', font:'milonga'} */
  var FONT_RE=new RegExp(' *'+String.fromCharCode(183)+'? *Font *: *([A-Za-z ]+) *$','i');
  function parse(text){
    var out=[];
    String(text||'').split(String.fromCharCode(10)).forEach(function(line){
      var m=line.match(/Design *([0-9]+)[^–—-]*[–—-] *(.*)$/);
      if(!m) return;
      var g=line.match(/Glass *([0-9]+)/i), nm=m[2].trim(), fm=nm.match(FONT_RE), fk=OLD_FONT;
      if(fm){ fk=fkey(fm[1]); nm=nm.slice(0,fm.index).trim(); }
      if(nm==='(no name)') nm='';
      out.push({g:g?+g[1]:out.length+1, d:+m[1], name:nm, font:fk});
    });
    return out;
  }
  function loadFont(k){
    var F=FONTS[k], done=false;
    function ok(){ if(done) return; done=true; FREADY[k]=true; changed(); }
    function test(){ if(!document.fonts||!document.fonts.load){ ok(); return; } document.fonts.load(face(k,40),'AMGCW Tyler').then(ok,ok); }
    setTimeout(ok,4000);
    if(F.src&&window.FontFace&&document.fonts){
      try{ var ff=new FontFace(F.family,'url('+F.src+')',{weight:String(F.weight)}); document.fonts.add(ff); ff.load().then(test,ok); }catch(e){ ok(); }
    } else if(F.css){
      var l=document.createElement('link'); l.rel='stylesheet'; l.href=F.css; l.onload=test; l.onerror=ok; document.head.appendChild(l);
    } else ok();
  }
  function loadFonts(){
    var extra=cfg().fonts||{};
    for(var k in extra){ var e=extra[k]; if(e&&e.family&&e.src) FONTS[k]={label:e.label||e.family,family:e.family,weight:e.weight||400,src:e.src,mixed:e.mixed!==false}; }
    for(var f in FONTS) loadFont(f);
  }
  function fontList(){ var o=[]; for(var k in FONTS) o.push({key:k,label:FONTS[k].label,family:FONTS[k].family,weight:FONTS[k].weight}); return o; }
  function loadLetters(){
    (cfg().letters||[]).forEach(function(u){
      if(!u) return;
      var sc=document.createElement('script'); sc.src=u; sc.async=true; sc.onload=changed;
      document.head.appendChild(sc);
    });
  }
  function fromCache(c,cb){
    var left=NP, out={}, bad=false;
    for(var n=1;n<=NP;n++){ (function(n){
      var im=new Image();
      im.onload=function(){ var cv=canvas(AW,AH); cv.getContext('2d').drawImage(im,0,0,AW,AH); out[n]=cv; if(--left===0) cb(bad?null:out); };
      im.onerror=function(){ bad=true; if(--left===0) cb(null); };
      im.src=c[n];
    })(n); }
  }
  function fresh(){
    var img=new Image();
    img.onload=function(){
      try{
        setArt(makeArt(img));
        var st={}; for(var n=1;n<=NP;n++) st[n]=ART[n].toDataURL('image/png');
        try{ localStorage.setItem(CACHE,JSON.stringify(st)); }catch(e){}
      }catch(e){}
    };
    img.src=cfg().src;
  }
  function loadArt(){
    try{ localStorage.removeItem('ggc-glass-tiles-v1'); }catch(e){}
    var c=null; try{ c=JSON.parse(localStorage.getItem(CACHE)||'null'); }catch(e){}
    setArt({});
    if(c&&c[1]&&c[NP]){ fromCache(c,function(out){ if(out) setArt(out); else fresh(); }); return; }
    fresh();
  }
  window.GGCGlass={
    names:NAMES, count:ND, width:AW, height:AH, fonts:fontList, fontKey:fkey, fontLabel:function(f){ return FONTS[fkey(f)].label; }, fontReady:function(f){ return !!FREADY[fkey(f)]; },
    init:function(){ if(started) return; started=true; loadArt(); loadFonts(); loadLetters(); loadGlass(); },
    onChange:function(f){ subs.push(f); },
    ready:function(){ return !!ART[1]; }, hasGlass:function(){ return !!GLASS; },
    label:function(n){ return 'Design '+n+' · '+NAMES[n-1]; },
    source:source, draw:draw, drawGlass:drawGlass, squeeze:squeeze, parse:parse
  };
})();
